import { createSelector } from 'redux-starter-kit';

const unitsNotTreeSelector = createSelector(['unit'], app => app.unitsNotTree)